import '~/pages/projects/blame/show/index';
import initBlob from '../../shared/init_blob';

initBlob();
